import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import phgVars from "./_phg-vars"

// update this boolean to true if you would like some helpful debugger consoles
const DEBUG = false

const Result = ({ files, info, resultKey }) => {
  const [name, setName] = useState(null)
  const [body, setBody] = useState(null)
  const [image, setImage] = useState(null)

  useEffect(() => {
    // get all the info items and get the contents of the text files
    let key = resultKey.split("_")[2]

    if (phgVars.brand === "Rosetta") key = resultKey.split("_")[1]

    const filteredInfo = info.filter((f) => {
      return f.key == key
    })

    if (filteredInfo[0]) {
      if (filteredInfo[0].name) {
        getInfo(filteredInfo[0].name.key)
          .then((response) => response.json())
          .then((result) => {
            setName(result.text)
            if (DEBUG) console.log(`key === ${key} : ${result.text}`)
          })
      }

      if (filteredInfo[0].body) {
        getInfo(filteredInfo[0].body.key)
          .then((response) => response.json())
          .then((result) => {
            setBody(result.text)
          })
      }

      if (filteredInfo[0].image) {
        getInfo(filteredInfo[0].image.key)
          .then((response) => response.json())
          .then((result) => {
            setImage(result.text)
          })
      }
    }
  }, [resultKey])

  async function getInfo(key) {
    return fetch(
      `${process.env.FUNCTIONS_URL}.netlify/functions/get-txt-contents?key=${encodeURI(key)}`
    )
  }

  // sort files
  const pdf = []
  const cad = []
  const calc = []
  const other = !files
    ? []
    : files.filter((file) => {
        let isOther = true
        if (file.caption === "Download PDF") {
          pdf.push(file)
          isOther = false
        }
        if (file.caption === "Download CAD") {
          cad.push(file)
          isOther = false
        }
        if (file.caption === "Download Backup Calcs") {
          calc.push(file)
          isOther = false
        }

        if (isOther) return file
      })

  const sortedFiles = [...pdf, ...cad, ...calc, ...other]

  const ctas = sortedFiles.map((result, i) => {
    return (
      <a href={result.url} target="_blank" rel="noreferrer" key={`file${i}`} className="btn">
        {result.caption}
      </a>
    )
  })

  return (
    <>
      <div className="result">
        {name && <h4>{name}</h4>}
        {body && <div dangerouslySetInnerHTML={{ __html: body }}></div>}
        {image && <img src={image} alt="" />}
        {ctas && <div>{ctas}</div>}
      </div>
      <hr />
    </>
  )
}

const Results = ({ results, info, noResults }) => {
  const resultsEl = useRef(null)
  const [sortedResults, setSortedResults] = useState([])
  const [isLoading, setLoading] = useState(false)

  // ----------------------------------------------- | Loading Indicator

  useEffect(() => {
    setLoading(true)
    let timeout = setTimeout(() => setLoading(false), 1200)

    return () => {
      clearTimeout(timeout)
    }
  }, [results, noResults])

  useEffect(() => {
    resultsEl.current.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }, [isLoading, sortedResults])

  // ----------------------------------------------- | Sort Results

  useEffect(() => {
    // sort results
    const SH = []
    const CB = []
    const E = []

    const B = []
    const L = []
    const XL = []
    const HC = []
    const PC = !results
      ? []
      : results.filter((result) => {
          const value =
            phgVars.brand === "Redi-Rock" ? result.key.split("_")[2] : result.key.split("_")[1]
          if (value == "SH") SH.push(result)
          if (value == "CB") CB.push(result)
          if (value == "30E") E.push(result)

          if (value == "B") B.push(result)
          if (value == "L") L.push(result)
          if (value == "XL") XL.push(result)
          if (value == "41HC") HC.push(result)
          if (value == "PC") return result
        })

    let sorted = [...B, ...HC, ...XL, ...L, ...PC]

    if (phgVars.brand === "Rosetta") sorted = [...SH, ...CB, ...E]

    if (DEBUG) {
      console.log("redi-rock order: B, HC, XL, L, PC")
      console.log("rosetta order: SH, CB, 30E")
      console.log(sorted)
    }

    setSortedResults(sorted)
  }, [results])

  return (
    <div ref={resultsEl}>
      {isLoading && (
        <div>
          <h2>Loading Results</h2>
          <div className="spinner"></div>
        </div>
      )}
      {!isLoading && sortedResults.length > 0 && (
        <div className="results-spacer">
          <h2>Results</h2>
          {sortedResults.map((result, i) => (
            <Result
              key={`result-${i}`}
              files={result.files}
              info={info}
              resultKey={result.key}
              noResults={result.noResults}
            />
          ))}
        </div>
      )}

      {!isLoading && noResults && (
        <div>
          <h2>No Results</h2>
          <p>Sorry! We were unable to locate any results that matched your search criteria.</p>
          <br />
        </div>
      )}
      <hr />
    </div>
  )
}

Results.propTypes = {
  results: PropTypes.array,
  info: PropTypes.array,
  noResults: PropTypes.bool
}

Result.propTypes = {
  files: PropTypes.array,
  info: PropTypes.array,
  resultKey: PropTypes.string
}

export default Results
